import React from 'react'
import { Suspense, lazy, useEffect, useState } from 'react'
import { AuthProvider } from './hooks/useAuth'
import { Cookies } from 'react-cookie'
import Logo from './assets/glemo-logo.webp'
import { DATE_ENTRY, DEVICE_ID } from './constants/storageNames'
import { isMobile, isValidStr } from './common_functions'
const AppRouter = lazy(() => import('./routes'))
import { Home, InternEnterprise } from './pages'
import Homef from './pages/Home/indexf'
import { InternEnterpriseTest } from './pages/Empreendimentos/InternEnterpriseTest'

export default function App() {
  const location = window.location
  const cookies = new Cookies()
  const [allowLocals, setAllowLocals] = useState(false)
  const [loadingComponents, setLoadingComponents] = useState(false)

  const isValidPathname = () => {
    return location.pathname != '/entrar' && location.pathname != '/registrar'
  }

  const handleLoad = () => {
    // alert('Invoked handle load')
    if (!loadingComponents) {
      const head = document.head
      const body = document.body

      const script1 = document.createElement('script')
      script1.defer = true
      script1.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }`
      head.appendChild(script1)

      const script2 = document.createElement('script')
      script2.defer = true
      script2.innerHTML = `(function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start': new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-WQ39T96');`
      head.appendChild(script2)

      const linkTiny = document.createElement('link')
      // <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.3/tiny-slider.css" />
      linkTiny.rel = 'stylesheet'
      linkTiny.href = 'https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.3/tiny-slider.css'
      head.appendChild(linkTiny)

      const script3 = document.createElement('script')
      script3.type = 'application/ld+json'
      script3.defer = true
      script3.innerHTML = `{
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "glemO",
      "alternateName": "glemo Imóveis",
      "url": "https://www.glemo.com.br",
      "logo": "https://www.glemo.com.br/assets/glemo-logo-2-c14faa1a.png",
      "sameAs": [
        "https://www.instagram.com/portalglemo/",
        "https://www.facebook.com/portalglemo"
      ]
    }`

      head.appendChild(script3)

      const adopt = document.createElement('meta')
      adopt.name = 'adopt-website-id'
      adopt.content = '2c1b73d6-dc7b-4ab5-845a-9797ac244096'

      head.appendChild(adopt)

      const scriptAdopt = document.createElement('script')
      scriptAdopt.defer = true
      scriptAdopt.src =
        '//tag.goadopt.io/injector.js?website_code=2c1b73d6-dc7b-4ab5-845a-9797ac244096'
      scriptAdopt.className = 'adopt-injector'

      head.appendChild(scriptAdopt)

      const linkfontsgoogleapi = document.createElement('link')
      linkfontsgoogleapi.rel = 'preconnect'
      linkfontsgoogleapi.href = 'https://fonts.googleapis.com'
      const linkfontsgtatic = document.createElement('link')
      linkfontsgtatic.rel = 'preconnect'
      linkfontsgtatic.href = 'https://fonts.gstatic.com'
      linkfontsgtatic.crossOrigin = 'true'

      head.appendChild(linkfontsgtatic)

      const script5 = document.createElement('script')
      script5.innerHTML = `document.addEventListener('df-messenger-opened', function (event) {
      let adPolicy = document.querySelector('#adopt-controller-button')
      if (adPolicy != undefined && window.screen.width < 769) {
        adPolicy.style.setProperty('display', 'none', 'important')
      }
    })
    `
      body.appendChild(script5)

      setLoadingComponents(true)
      window.removeEventListener('touchstart', handleLoad)
      window.removeEventListener('touchmove', handleLoad)
      window.removeEventListener('scroll', handleLoad)
      window.removeEventListener('click', handleLoad)
    }
  }

  useEffect(() => {
    if (isMobile()) {
      window.addEventListener('touchstart', handleLoad)
      window.addEventListener('touchmove', handleLoad)
      window.addEventListener('scroll', handleLoad)
      window.addEventListener('click', handleLoad)

      return () => {
        window.removeEventListener('touchstart', handleLoad)
        window.removeEventListener('touchmove', handleLoad)
        window.removeEventListener('scroll', handleLoad)
        window.removeEventListener('click', handleLoad)
      }
    } else {
      window.addEventListener('load', handleLoad)
      return () => {
        window.removeEventListener('load', handleLoad)
      }
    }
  }, [location.pathname])

  useEffect(() => {
    if (!isMobile()) {
      setTimeout(() => {
        if (!loadingComponents) {
          setLoadingComponents(true)
        }
      }, 3000)
    }
  }, [])

  useEffect(() => {
    if (location.pathname != '/' && !location.pathname.includes('empreendimentos')) handleLoad()
  }, [location.pathname])

  // useEffect(() => {
  //   window.addEventListener('load', handleLoad)
  //   return () => {
  //     window.removeEventListener('load', handleLoad)
  //   }
  // }, [])

  // useEffect(() => {
  //   if (isMobile()) {
  //     const waitForImagesToLoad = (): Promise<void> => {
  //       const images: HTMLImageElement[] = Array.from(document.images) as HTMLImageElement[]
  //       if (images.length === 0) {
  //         return Promise.resolve()
  //       }
  //       const promises = images.map((img) => {
  //         if (img.complete) {
  //           return Promise.resolve()
  //         }
  //         return new Promise<void>((resolve) => {
  //           img.onload = img.onerror = () => resolve()
  //         })
  //       })
  //       return Promise.all(promises).then(() => {})
  //     }

  //     waitForImagesToLoad().then(() => {
  //       // alert('Página completamente carregada com todas as imagens.');
  //       setTimeout(() => {
  //         if (!loadingComponents) {
  //           handleLoad()
  //         }
  //       }, 5000)
  //     })
  //   }
  // }, [loadingComponents])

  useEffect(() => {
    if (isValidPathname()) {
      setAllowLocals(true)
    }
    addDateEntry()
    addDeviceId()
  }, [location.pathname])

  const addDateEntry = () => {
    let dateEntryAux = sessionStorage.getItem(DATE_ENTRY)
    if (!isValidStr(dateEntryAux)) {
      sessionStorage.setItem(DATE_ENTRY, new Date().toISOString())
    }
  }

  const randomNumberInRange = () => {
    return Math.floor(Math.random() * (10000 - 0 + 1)) + 0
  }

  const addDeviceId = () => {
    let deviceId = cookies.get(DEVICE_ID)
    if (deviceId == undefined || deviceId == null || deviceId == 0) {
      cookies.set(DEVICE_ID, randomNumberInRange())
    }
  }

  return (
    <div className={`h-full app-root`}>
      <AuthProvider>
        <Suspense fallback={<div id="loadingBox"></div>}>
          {/* <AppRouter /> */}
          {/* {loadingComponents ? (
            <AppRouter />
          ) : ( */}
          <>
            {location.pathname == '/' ? (
              <>
                <Home isDocumentReady={loadingComponents} />
              </>
            ) : (
              <>
                <>
                  {location.pathname.includes('/empreendimentos') ? (
                    <>
                      <InternEnterpriseTest isLoadingFull={loadingComponents} />
                    </>
                  ) : (
                    <>
                      <AppRouter />
                    </>
                  )}
                </>
              </>
            )}
          </>
          {/* )} */}
        </Suspense>
      </AuthProvider>
    </div>
  )
}
